import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable, produce } from 'immer';
import { OrderedSet } from 'immutable';

interface IDepotItemEntity {
	id: number;
	code: string;
	label: string;
	type: string;
	isActive: boolean;
	isImported: boolean;
	description: string;
	tags: OrderedSet<AppTagItemEntity>;
	updateDate: Date | null;
	updatedBy: string;
	creationDate: Date | null;
	createdBy: string;
	updatedByAvatar: AvatarEntity | null;
	createdByAvatar: AvatarEntity | null;
	pictogramUrl: string;
	entitiesCount: number | null;
	connectorLabel: string;
	connectorType: string;
	connectorUrl: string;
	typeDescription: string;
}

const entityDefaults: IDepotItemEntity = {
	id: -1,
	label: '',
	code: '',
	description: '',
	tags: OrderedSet(),
	updateDate: null,
	updatedBy: '',
	creationDate: null,
	createdBy: '',
	isActive: false,
	updatedByAvatar: null,
	createdByAvatar: null,
	pictogramUrl: '',
	isImported: false,
	entitiesCount: null,
	connectorLabel: '',
	connectorUrl: '',
	connectorType: '',
	type: '',
	typeDescription: '',
};

export class DepotItemEntity implements IDepotItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public code = entityDefaults.code;
	public description = entityDefaults.description;
	public label = entityDefaults.label;
	public tags = entityDefaults.tags;
	public updateDate = entityDefaults.updateDate;
	public updatedBy = entityDefaults.updatedBy;
	public creationDate = entityDefaults.creationDate;
	public createdBy = entityDefaults.createdBy;
	public isActive = entityDefaults.isActive;
	public updatedByAvatar = entityDefaults.updatedByAvatar;
	public createdByAvatar = entityDefaults.createdByAvatar;
	public pictogramUrl = entityDefaults.pictogramUrl;
	public isImported = entityDefaults.isImported;
	public entitiesCount = entityDefaults.entitiesCount;
	public connectorLabel = entityDefaults.connectorLabel;
	public connectorUrl = entityDefaults.connectorUrl;
	public connectorType = entityDefaults.connectorType;
	public type = entityDefaults.type;
	public typeDescription = entityDefaults.typeDescription;

	public static build(params: Partial<IDepotItemEntity> = {}): DepotItemEntity {
		const entity = new DepotItemEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.code = params.code ?? entityDefaults.code;
		entity.description = params.description ?? entityDefaults.description;
		entity.label = params.label ?? entityDefaults.label;
		entity.tags = params.tags ?? entityDefaults.tags;
		entity.updateDate = params.updateDate ?? entityDefaults.updateDate;
		entity.updatedBy = params.updatedBy ?? entityDefaults.updatedBy;
		entity.creationDate = params.creationDate ?? entityDefaults.creationDate;
		entity.createdBy = params.createdBy ?? entityDefaults.createdBy;
		entity.isActive = params.isActive ?? entityDefaults.isActive;
		entity.createdByAvatar =
			params.createdByAvatar ?? entityDefaults.createdByAvatar;
		entity.isImported = params.isImported ?? entityDefaults.isImported;
		entity.entitiesCount = params.entitiesCount ?? entityDefaults.entitiesCount;
		entity.pictogramUrl = params.pictogramUrl ?? entityDefaults.pictogramUrl;
		entity.connectorLabel =
			params.connectorLabel ?? entityDefaults.connectorLabel;
		entity.connectorUrl = params.connectorUrl ?? entityDefaults.connectorUrl;
		entity.connectorType = params.connectorType ?? entityDefaults.connectorType;
		entity.type = params.type ?? entityDefaults.type;
		entity.typeDescription =
			params.typeDescription ?? entityDefaults.typeDescription;
		if (params.updatedBy) {
			entity.updatedByAvatar = AvatarEntity.build(params.updatedBy);
		}
		if (params.createdBy) {
			entity.createdByAvatar = AvatarEntity.build(params.createdBy);
		}
		return entity;
	}

	public updateEntityCount(entityCount: number): DepotItemEntity {
		return produce(this, (draft) => {
			draft.entitiesCount = entityCount;
		});
	}
}
